import Repository from "./Repository";

const CREATE = "add";
const GET = "get";
const UPDATE = "edit";
const DELETE = "delete";

export default {
  createPartners(payload) {
    return Repository.post(transformRoute(CREATE), payload);
  },
  getPartners(payload) {
    return Repository.post(transformRoute(GET), payload);
  },
  updatePartners(payload) {
    return Repository.post(transformRoute(UPDATE), payload);
  },
  deletePartners(payload) {
    return Repository.post(transformRoute(DELETE), payload);
  },
};

const transformRoute = (route) => {
  return `/partners/${route}`;
};
